var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[(_vm.isLoaded)?_c('CardForm',{attrs:{"form-data":_vm.formData,"loading":_vm.loading},on:{"save-card":_vm.save}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }